module.exports = __webpack_public_path__ + "img/icon_home.2cac1cdc.svg";